import { existsSync } from 'node:fs';
import { getExtensionPath } from '@wix/cli-astro-definitions';

const VALID_PATH_REGEX = /^[a-z0-9\-/]+$/;

const VALID_UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function pathValidation(path: string): boolean {
  return VALID_PATH_REGEX.test(path);
}

export function pathAvailableValidation(projectFolder: string) {
  return function (folder: string) {
    return !existsSync(getExtensionPath(projectFolder, folder));
  };
}

export function uuidValidation(id: string): boolean {
  return VALID_UUID_REGEX.test(id);
}

type ValidationResult = { valid: true } | { valid: false; reason: string };

export function composeValidations<T>(
  validations: Array<[(value: T) => boolean, reason: string]>
): (value: T) => ValidationResult {
  return (value) => {
    for (const [validation, reason] of validations) {
      if (!validation(value)) {
        return { valid: false, reason };
      }
    }
    return { valid: true };
  };
}

export function useValidation<T>(fn: (value: T) => ValidationResult) {
  return (value: T): true | string => {
    const result = fn(value);
    return result.valid || result.reason;
  };
}
